import { render, staticRenderFns } from "./ticketdepartment.vue?vue&type=template&id=1ee96443"
import script from "./ticketdepartment.vue?vue&type=script&lang=js"
export * from "./ticketdepartment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports